import { getApiUrl } from './apiBaseUrl'

const parseJsonOrFallback = async (response, fallback, onParseError) => {
  try {
    const parsed = await response.json()
    return parsed ?? fallback
  } catch (error) {
    if (onParseError) {
      onParseError(error)
    }
    return fallback
  }
}

const fetchJsonRequest = async (url, {
  method = 'GET',
  headers = {},
  body,
  credentials,
  fallback = {},
  throwOnHttpError = false,
  errorMessage = 'Request failed',
  onParseError
} = {}) => {
  const response = await fetch(getApiUrl(url), {
    method,
    headers: {
      Accept: 'application/json',
      ...headers
    },
    ...(body === undefined ? {} : { body }),
    ...(credentials === undefined ? {} : { credentials })
  })

  const data = await parseJsonOrFallback(response, fallback, onParseError)

  if (throwOnHttpError && !response.ok) {
    throw new Error(`${errorMessage} (${response.status})`)
  }

  return { response, data }
}

export default fetchJsonRequest
